<template>
  <div class="splash-container">
    <div class="splash-content">
      <div class="logo-container">
        <img :src="logoUrl" alt="JLHVISION" class="splash-logo">
      </div>
      <div class="stars-container">
        <div class="stars-loader">
          <i class="material-icons">star</i>
          <i class="material-icons">star</i>
          <i class="material-icons">star</i>
          <i class="material-icons">star</i>
          <i class="material-icons">star</i>
          <i class="material-icons">star</i>
          <i class="material-icons">star</i>
        </div>
        <p class="text-splash">Noticias de Venezula y el Mundo.</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const logoUrl = ref('/logo-transparente.png')

onMounted(() => {
  setTimeout(() => {
    const token = localStorage.getItem('auth_token')
    window.location.href = token ? '/home' : '/login'
  }, 2500)
})
</script>

<style scoped>
.splash-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #001b4a;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.splash-content {
  text-align: center;
}

.logo-container {
  margin-bottom: 40px;
}

.splash-logo {
  width: 100px;
  object-fit: contain;
}

.stars-container {
  margin-top: 20px;
}

.stars-loader {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.stars-loader i {
  font-size: 24px;
  color: white;
  animation: starWave 0.8s ease-in-out infinite;
  opacity: 0.3;
}

.stars-loader i:nth-child(1) { animation-delay: 0s; }
.stars-loader i:nth-child(2) { animation-delay: 0.1s; }
.stars-loader i:nth-child(3) { animation-delay: 0.2s; }
.stars-loader i:nth-child(4) { animation-delay: 0.3s; }
.stars-loader i:nth-child(5) { animation-delay: 0.4s; }
.stars-loader i:nth-child(6) { animation-delay: 0.5s; }
.stars-loader i:nth-child(7) { animation-delay: 0.6s; }

@keyframes starWave {
  0%, 100% {
    transform: scale(1);
    opacity: 0.3;
  }
  50% {
    transform: scale(1.3);
    opacity: 1;
  }
}

.text-splash{
    font-size: 14px;
    padding-top: 10px;
    color: #fff;
}
</style>